var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-page',{staticClass:"page-vault d-flex __column",attrs:{"loading":_vm.loading}},[_c('vault-controller',{staticClass:"px-4",on:{"loading":function (v) { return (_vm.loading = v); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }